import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_SET_WA,
  AUTH_SET_SIGNATURE,
  AUTH_PR_REQUEST,
  AUTH_PC_REQUEST,
  AUTH_GET_ROLES
} from '../actions/auth'

import axios from 'axios'
import router from '../../router'
import { UI_FREE_APPLICATION, UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'

const state = {
  token: localStorage.getItem('fuel-user-token') || '',
  status: '',
  hasLoadedOnce: false,
  currentWA: {},
  WAList: [],
  RolesList: []
}

const getters = {
  isAuthenticated: state => {
    // console.log('Authentication state requested')
    return !!state.token
  },
  getUserToken: state => {
    const usrToken = JSON.parse(state.token)
    // console.log('User token requested ', usrToken)
    return usrToken
  },
  getUserRole: state => {
    // console.log('auth Module: User role requested ')
    if (state.token !== '') {
      const locToken = JSON.parse(state.token)
      return locToken.roles[0]
    } else {
      return -1
    }
  },
  getCurrentWAList: state => {
    console.log('User WAList requested ')
    if (state.token !== '') {
      const locToken = JSON.parse(state.token)
      console.log('User WAList returning ', locToken.depts)
      return locToken.depts
    } else {
      return []
    }
  },
  getCurrentWA: state => {
    console.log('User current WA requested ')
    if (state.token !== '') {
      const locToken = JSON.parse(state.token)
      console.log('User current WA is ', locToken.WA.DEPT_UUID)
      return locToken.WA.DEPT_UUID
    } else {
      return []
    }
  },
  getCurrentSign: state => {
    console.log('Request signature requested ')
    let locToken
    if (state.token !== '') {
      locToken = JSON.parse(state.token)
    } else {
      return null
    }
    return locToken.sign
  },
  getUserDeptBoss: state => {
    console.log('User boss flag requested ')
    let locToken = ''
    if (state.token !== '') {
      locToken = JSON.parse(state.token)
    } else {
      return false
    }
    return locToken.flags === '1'
  },
  getRolesList: state => {
    return state.RolesList
  }
}

const actions = {
  [AUTH_SET_SIGNATURE]: ({ commit, dispatch }, signature) => {
    return new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AUTH_SET_SIGNATURE', topic: 'Установка текущей подписи', error: null })
      commit(AUTH_SET_SIGNATURE, signature)
      dispatch(UI_SUCCESS, { action: 'AUTH_SET_SIGNATURE' })
      resolve()
    })
  },
  [AUTH_ERROR]: ({ commit, dispatch }, error) => {
    return new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AUTH_ERROR', topic: 'Ошибка авторизации', error: null })
      switch (error.error_code) {
        case -1:
          dispatch(AUTH_LOGOUT)
          break
        case -2:
          dispatch(AUTH_LOGOUT)
          break
        case -7:
          dispatch(AUTH_LOGOUT)
          break
      }
      dispatch(UI_SUCCESS, { action: 'AUTH_ERROR' })
      resolve(error.error_code)
    })
  },
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      dispatch(UI_REQUEST, { action: 'AUTH_REQUEST', topic: 'Запрос аутентификации', error: null })
      user.command = 'login'
      axios({ url: '/api/auth/auth.php', data: user, method: 'POST' })
        .then(resp => {
          // console.log('Auth action :: login completed with result ', resp.data)
          if (resp.data.error === 'ok') {
            commit(AUTH_SUCCESS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'AUTH_REQUEST' })
            resolve(resp.data)
          } else {
            dispatch(AUTH_ERROR, resp.data)
            dispatch(UI_ERROR, { action: 'AUTH_REQUEST', result: resp.data.error_text })
            resolve(resp.data)
          }
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          dispatch(UI_ERROR, { action: 'AUTH_REQUEST', result: err })
          localStorage.removeItem('keeper-user-token')
          reject(err)
        })
    })
  },
  [AUTH_PR_REQUEST]: ({ commit, dispatch }, request) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      dispatch(UI_REQUEST, { action: 'AUTH_PR_REQUEST', topic: 'Запрос восстановления пароля', error: null })
      axios({ url: '/api/auth/restorePass.php', data: request, method: 'POST' })
        .then(resp => {
          // console.log('Auth action :: password resore request completed with result ', resp.data)
          if (resp.data.error === 'ok') {
            // commit(AUTH_SUCCESS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'AUTH_PR_REQUEST' })
            resolve(resp.data)
          } else {
            // dispatch(AUTH_ERROR, resp.data)
            dispatch(UI_ERROR, { action: 'AUTH_PR_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch(err => {
          // commit(AUTH_ERROR, err)
          dispatch(UI_ERROR, { action: 'AUTH_PR_REQUEST', result: err })
          reject(err)
        })
    })
  },
  [AUTH_PC_REQUEST]: ({ commit, dispatch }, request) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      dispatch(UI_REQUEST, { action: 'AUTH_PC_REQUEST', topic: 'Обновление пароля', error: null })
      axios({ url: '/api/auth/renewPass.php', data: request, method: 'POST' })
        .then(resp => {
          console.log('Auth action :: password renew request completed with result ', resp.data)
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AUTH_PC_REQUEST' })
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AUTH_PC_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch(err => {
          dispatch(UI_ERROR, { action: 'AUTH_PC_REQUEST', result: err })
          reject(err)
        })
    })
  },
  [AUTH_SET_WA]: ({ commit, dispatch }, dept) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      dispatch(UI_REQUEST, { action: 'AUTH_SET_WA', topic: 'Запрос смены роли', error: null })
      axios({ url: '/api/auth/setRole.php', data: dept, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            console.log('AUTH_SET_WA :: WA changed success ', resp.data)
            commit(AUTH_SUCCESS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'AUTH_SET_WA' })
            resolve(resp.data)
          } else {
            dispatch(AUTH_ERROR, resp.data.error_text)
            dispatch(UI_ERROR, { action: 'AUTH_SET_WA', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          dispatch(UI_ERROR, { action: 'AUTH_SET_WA', result: err })
          localStorage.removeItem('fuel-user-token')
          reject(err)
        })
    })
  },
  [AUTH_GET_ROLES]: ({ commit, dispatch }, dept) => {
    return new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AUTH_GET_ROLES', topic: 'Запрос списка ролей', error: null })
      axios({ url: '/api/org/admin/getSystemRoles.php', data: dept, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AUTH_GET_ROLES' })
            commit(AUTH_GET_ROLES, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(AUTH_LOGOUT, resp.data.error_text)
            dispatch(UI_ERROR, { action: 'AUTH_GET_ROLES', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch(err => {
          commit(AUTH_LOGOUT, err)
          dispatch(UI_ERROR, { action: 'AUTH_GET_ROLES', result: err })
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AUTH_LOGOUT', topic: 'Завершение аутентификации', error: null })
      var params = { command: 'logout' }
      axios({ url: '/api/auth/auth.php', data: params, method: 'POST' })
        .then(resp => {
          console.log('Logout procedure got server response ', resp.data)
          if (resp.data.error === 'ok') {
            dispatch(UI_FREE_APPLICATION)
              .then(() => {
                dispatch(UI_SUCCESS, { action: 'AUTH_LOGOUT' })
                resolve()
              })
              .catch((err) => {
                dispatch(UI_ERROR, { action: 'AUTH_LOGOUT', result: err })
                reject(err)
              })
          } else {
            dispatch(AUTH_ERROR, resp.data.error_text)
            dispatch(UI_ERROR, { action: 'AUTH_LOGOUT', result: resp.data.error_text })
            reject(resp.data)
          }
        })
        .catch((err) => {
          console.log('Logout procedure got server error ', err)
          dispatch(UI_ERROR, { action: 'AUTH_LOGOUT', result: err })
          reject(err)
        })
        .finally(() => {
          commit(AUTH_LOGOUT)
          if (router.currentRoute.path !== '/login') router.push('/login')
        })
    })
  }
}

const postInterceptor = axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('fuel-user-token')
  if (token) {
    const locToken = JSON.parse(token)
    // axios.defaults.headers.common.Signature = locToken.sign
    config.headers.Signature = locToken.sign
  } else {
    // axios.defaults.headers.common.Signature = ''
    config.headers.Signature = ''
  }
  return config
})

const respInterceptor = axios.interceptors.response.use(function (response) {
  return response
})

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    console.log('AUTH_SUCCESS mutation initiated')
    const tokenString = JSON.stringify(resp)
    localStorage.setItem('fuel-user-token', tokenString)
    axios.defaults.headers.common.Signature = resp.sign
    state.token = tokenString
    state.hasLoadedOnce = true
  },
  [AUTH_GET_ROLES]: (state, resp) => {
    state.RolesList.splice(0, state.RolesList.length, ...resp)
  },
  [AUTH_ERROR]: state => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: state => {
    console.log('AUTH_LOGOUT mutation initiated')
    axios.defaults.headers.common.Signature = ''
    localStorage.removeItem('fuel-user-token')
    state.token = ''
    axios.interceptors.request.eject(postInterceptor)
    axios.interceptors.response.eject(respInterceptor)
    state.hasLoadedOnce = false
    state.currentWA = {}
    state.WAList.splice(0, state.WAList.length)
    state.RolesList.splice(0, state.RolesList.length)
  },
  [AUTH_SET_SIGNATURE]: (state, resp) => {
    console.log('AUTH_SET_SIGNATURE mutation initiated', resp)
    let locToken
    if (state.token !== '') {
      locToken = JSON.parse(state.token)
      locToken.sign = resp
      const tokenString = JSON.stringify(locToken)
      localStorage.setItem('fuel-user-token', tokenString)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
